import { configureStore, ThunkAction, Action, combineReducers } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import authSlice from 'features/auth/authSlice';
import rolSlice from 'features/Administrador/rol/rolSlice';
import modalBaseSlice from 'features/modal/modalBaseSlice';
import loaderSlice from 'features/loader/loaderSlice';
import menuSlice from 'features/menu/menuSlice';
import toastBaseSlice from 'features/toast/toastBaseSlice';
import permisoSlice from 'features/Administrador/permiso/permisoSlice';
import opcionSlice from 'features/Administrador/opcion/opcionSlice';
import usuarioSlice from 'features/Administrador/ususario/usuarioSlice';
import facilitadorSlice from 'features/Administrador/facilitador/facilitadorSlice';
import generoSlice from 'features/Administrador/catalogo/generoSlice';
import ocupacionSlice from 'features/Administrador/catalogo/ocupacionSlice';
import alumnoSlice from 'features/Administrador/alumno/alumnoSlice';
import departamentoSlice from 'features/Administrador/catalogo/departamentoSlice';
import municipioSlice from 'features/Administrador/catalogo/municipioSlice';
import gradoSlice from 'features/Administrador/catalogo/gradoSlice';
import promedioSlice from 'features/Administrador/catalogo/promedioSlice';
import centroSlice from 'features/Administrador/catalogo/centroSlice';
import parentescoSlice from 'features/Administrador/catalogo/parentescoSlice';
import relacionSlice from 'features/Administrador/catalogo/relacionSlice';
import actividadExtraSlice from 'features/Administrador/catalogo/actividadExtraSlice';
import idiomaSlice from 'features/Administrador/catalogo/idiomaSlice';
import catalogoSlice from 'features/Administrador/catalogo/catalogoSlice';
import insigniaSlice from 'features/Administrador/catalogo/insigniaSlice';
import diplomadoSlice from 'features/Administrador/diplomado/diplomadoSlice';
import cicloSlice from 'features/Administrador/diplomado/cicloSlice';
import moduloSlice from 'features/Administrador/diplomado/moduloSlice';
import sesionSlice from 'features/Administrador/diplomado/sesionSlice';
import recursoSlice from 'features/Administrador/diplomado/recursoSlice';
import evaluacionSlice from 'features/Administrador/diplomado/evaluacionSlice';
import preguntaSlice from 'features/Administrador/diplomado/preguntaSlice';
import respuestaSlice from 'features/Administrador/diplomado/respuestaSlice';
import loginSlice from 'features/login/loginSlice';
import grupoSlice from 'features/Administrador/diplomado/grupoSlice';
import alumnoInscritoSlice from 'features/Administrador/diplomado/alumnoInscritoSlice';
import alumnoAsignadoSlice from 'features/Administrador/diplomado/alumnoAsignadoSlice';
import grupoModuloSlice from 'features/Administrador/diplomado/grupoModuloSlice';
import grupoSesionSlice from 'features/Administrador/diplomado/grupoSesionSlice';
import facilitadorSesionSlice from 'features/Facilitador/facilitadorSesionSlice';
import facilitadorAlumnoSesionSlice from 'features/Facilitador/alumnoSesionslice';
import actividadSesion  from 'features/Facilitador/actividadSesionSlice';
import calificacionSlice from 'features/Facilitador/calificacionSlice';
import facilitadorDashboardSlice from 'features/Facilitador/dashboardSlice';
import facilitadorEvaluacionSlice from 'features/Facilitador/evaluacionSlice';
import facilitadorGrupoSlice from 'features/Facilitador/grupoSlice';
import facilitadorDetalleCicloSlice from 'features/Facilitador/detalleCicloSlice';
import facilitadorAlumnoSlice from 'features/Facilitador/alumnoSlice';
import facilitadorResultadoSlice from 'features/Facilitador/resultadoSlice';
import facilitadorDiplomaSlice from 'features/Facilitador/diplomaSlice';
import alumnoDashboardSlice from 'features/Alumno/dashboardSlice';
import alumnoCicloSlice from 'features/Alumno/cicloSlice';
import alumnoModuloSlice from 'features/Alumno/moduloSlice';
import alumnoSesionSlice from 'features/Alumno/sesionSlice';
import alumnoEntregaSlice from 'features/Alumno/entregaSlice';
import alumnoEvaluacionSlice from 'features/Alumno/evaluacionSlice';
import alumnoProfileSlice from 'features/Alumno/profileSlice';
import alumnoSolicitudSlice from 'features/Alumno/solicitudSlice';
import alumnoCuentaSlice from 'features/Alumno/cuentaSlice';
import alumnoDiplomaSlice from 'features/Alumno/diplomaSlice';
import adminSolicitudSlice from 'features/Administrador/solicitud/solicitudSlice';
import registerSlice from 'features/public/registerSlice';
import publicCatalogSlice from 'features/public/catalogSlice';

const persistConfig: any = {
    key: 'lid-acc',
    storage,
};


const reducer = combineReducers({
    auth: persistReducer(persistConfig, authSlice),
    login: loginSlice,
    menu: menuSlice,
    rol: rolSlice,
    modalBase: modalBaseSlice,
    loader: loaderSlice,
    toastBase: toastBaseSlice,
    permiso: permisoSlice,
    opcion: opcionSlice,
    usuario: usuarioSlice,
    facilitador: facilitadorSlice,
    genero: generoSlice,
    ocupacion: ocupacionSlice,
    alumno: alumnoSlice,
    departamento: departamentoSlice,
    municipio: municipioSlice,
    grado: gradoSlice,
    promedio: promedioSlice,
    centro: centroSlice,
    parentesco: parentescoSlice,
    relacion: relacionSlice,
    actividadExtra: actividadExtraSlice,
    idioma: idiomaSlice,
    catalogo: catalogoSlice,
    insignia: insigniaSlice,
    diplomado: diplomadoSlice,
    ciclo: cicloSlice,
    modulo: moduloSlice,
    sesion: sesionSlice,
    recurso: recursoSlice,
    evaluacion: evaluacionSlice,
    pregunta: preguntaSlice,
    respuesta: respuestaSlice,
    grupo: grupoSlice,
    alumnoInscrito: alumnoInscritoSlice,
    alumnoAsignado: alumnoAsignadoSlice,
    grupoModulo: grupoModuloSlice,
    grupoSesion: grupoSesionSlice,
    facilitadorSesion: facilitadorSesionSlice,
    facilitadorAlumnoSesion: facilitadorAlumnoSesionSlice,
    actividadSesion: actividadSesion,
    calificacion: calificacionSlice,
    facilitadorDashboard: facilitadorDashboardSlice,
    facilitadorEvaluacion: facilitadorEvaluacionSlice,
    facilitadorGrupo: facilitadorGrupoSlice,
    facilitadorDetalleCiclo: facilitadorDetalleCicloSlice,
    facilitadorAlumno: facilitadorAlumnoSlice,
    facilitadorResultado: facilitadorResultadoSlice,
    facilitadorDiplomas: facilitadorDiplomaSlice,
    alumnoDashboard: alumnoDashboardSlice,
    alumnoCiclo: alumnoCicloSlice,
    alumnoModulo: alumnoModuloSlice,
    alumnoSesion: alumnoSesionSlice,
    alumnoEntrega: alumnoEntregaSlice,
    alumnoEvaluacion: alumnoEvaluacionSlice,
    alumnoProfile: alumnoProfileSlice,
    alumnoSolicitud: alumnoSolicitudSlice,
    alumnoCuenta: alumnoCuentaSlice,
    alumnoDiplomas: alumnoDiplomaSlice,
    solicitudAdmin: adminSolicitudSlice,
    register: registerSlice,
    publicCatalog: publicCatalogSlice,
});

export const store = configureStore({
    reducer,
    devTools: process.env.NODE_ENV !== 'production',
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
});

export const persistor = persistStore(store);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;
